import { styled, Typography, Box, Stack } from '@mui/material'
import { IRuleset, ILoanAssessment } from '@/types'
import { RULES_STATUS } from '@/utils/constants'
import { DataTable } from '@/components/UI/DataTable'
import { transformedColumns, replaceNullValues } from '@/utils/common'
import { ITableColumn } from '@/components/UI/DataTable/TableHead'
import { Chip } from '@/components/UI/Chip'
import { columns } from '../Columns'

interface AssessmentRulesProps {
  title: string
  assessment: ILoanAssessment
}

export const AssessmentRules: React.FC<AssessmentRulesProps> = ({
  title,
  assessment
}) => {
  const safeAssessment = replaceNullValues<ILoanAssessment>(assessment)

  return (
    <Box p={2}>
        <StyledTypography>{title}</StyledTypography>
      <DataTable<IRuleset>
        rows={safeAssessment.rules}
        columns={transformedColumns(columns) as ITableColumn<IRuleset>[]}
        loadingState={false}
        footerContent={
          safeAssessment.rules?.length > 0 && (
            <Box
              px={3.3}
              py={1.5}
              sx={{
                backgroundColor:
                  safeAssessment.eligibilityStatus?.toLowerCase() ===
                  RULES_STATUS.PASS
                    ? 'rgba(6, 118, 71, 0.1)'
                    : 'rgba(201, 39, 43, 0.1)',
                borderBottom: '1px solid #EAECF0',
              }}
            >
              <Stack alignItems="center" direction="row" gap={4}>
                <StyledText sx={{ fontWeight: 'bold' }}>Result</StyledText>
                <Chip value={safeAssessment.eligibilityStatus?.toUpperCase()} />
              </Stack>
            </Box>
          )
        }
      />
    </Box>
  )
}

const StyledText = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  textAlign: 'left',
  color: '#475467',
}))

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontFamily: 'Inter',
  fontWeight: 600,
  color: '#344054',
  textTransform: 'capitalize',
  marginLeft: '10px',
  [theme.breakpoints.down('md')]: {
    marginLeft: '0px',
  },
}))
